export const onChange = () => ({
  onPayChange(state, val) {
    return { payEnabled: val };
  },
  onSelectChange(state, selected) {
    return { selected };
  },
  onSubSelectChange(state, subSelected) {
    return { subSelected };
  },
  onLoginDataChange(state, payOption) {
    return {
      payData: payOption.payData,
      wallet: payOption.wallet,
      mgv: payOption.mgv,
      loginInfo: payOption.loginInfo
    };
  },
  onSessionExpire(state, sessionExpired) {
    return {
      sessionExpired
    };
  },
  onOtpSentChange(state, show) {
    return {
      showOtpSent: show
    };
  },
  onPayDataChange(state, paymentOptions) {
    return { payData: paymentOptions.payData };
  },
  onWalletToggle(state, wallet) {
    return { wallet };
  },
  onOverlayValueChange(state, overlayValue) {
    return { overlayValue };
  },
  onRetryMessageChange(state, message) {
    return {
      retryMessage: message
    };
  },
  onBtnTextChange(state, text, btnSubText) {
    return { btnText: text, btnSubText };
  },
  onSelectedPlan(state, selectedEmiPlan) {
    return { selectedEmiPlan };
  },
  onStopScroll(state, stopScroll) {
    return { stopScroll };
  },
  onHelperOverlayToggle(state, showHelperOverlay) {
    return { showHelperOverlay };
  },
  onNotificationTextChange(state, notificationMsg) {
    return { notificationMsg };
  },
  onHighlightOfferError(state, shouldHighlightOfferError) {
    return { shouldHighlightOfferError };
  },
  toggleDirectBank(state, directBankData) {
    return { directBankData };
  }
});



// WEBPACK FOOTER //
// ./common/actions.js